<template>
  <div id="course-assessment-summary">
    <dash-header :pages="breadCrumbsPages" :dashboardTitle="'Comparative Assessment'"/>
     <a-layout id="components-layout-demo-custom-trigger">
      <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.courseSubmitters"
        v-if="userRole === 'telas_course_submitters'"/>
        <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.admin"
        v-if="userRole === 'telas_telas_administrator'"/>
        <dash-sidebar
        defaultSelectedKeys="0"
        :menuItems="commonMenuItems.assessors"
        v-else />
      <a-layout-content :style="{ margin: '24px 16px', padding: '24px', background: '#fff', minHeight: '280px' }">
        <report-summary-card
          :reportId="reportId"
          :courseDetails="courseDetails"
          :style="{ marginBottom: '20px' }"
          :isComparative="true"
        />
        <comparative-review-summary
          v-if="reportData.report_details"
          :adminReviewerAssessmentData="reportData.report_details.admin_reviewer_assessment_data.review_data"
          :firstReviewerAssessmentData="reportData.report_details.first_reviewer_assessment_data.review_data"
          :secondReviewerAssessmentData="reportData.report_details.second_reviewer_assessment_data.review_data"
          :reportStatus="reportData.report_details.assessment_status"
        />
      </a-layout-content>
    </a-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import dashHeader from '@src/views/dashboard/Header.vue';
import dashSidebar from '@src/views/dashboard/Sidebar.vue';
import comparativeReviewSummary from '@/components/dashboard/Comparative-review-summary.vue';
import reportSummaryCard from '../report/Report-summary-card.vue';

export default {
  name: 'comparative-course-assessment-summary',
  data() {
    return {
      breadCrumbsPages: [
        {
          name: 'Home',
          route: '/',
        },
        {
          name: 'Dashboard',
          route: '/dashboard',
        },
        {
          name: 'Comparative Assessment',
          route: `/dashboard/comparative-summary/${this.$route.params.reportId}`,
        },
      ],
      reportId: this.$route.params.reportId,
    };
  },
  components: {
    comparativeReviewSummary,
    dashHeader,
    dashSidebar,
    reportSummaryCard,
  },
  computed: {
    ...mapGetters('user', {
      userRole: 'getUserRole',
      userToken: 'getUserToken',
    }),
    ...mapState('assessments', {
      reportData: state => state.combinedReview,
    }),
    ...mapState('courses', {
      courseDetails: state => state.courseDetails,
    }),
  },
  methods: {
    ...mapActions('assessments', {
      getReportById: 'getReportById',
    }),
    ...mapActions('courses', {
      getCourseById: 'getCourseById',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      if (this.userToken !== undefined) {
        this.getReportById({
          reportId: this.reportId,
          userToken: this.userToken,
        });
      }
    });
  },
  watch: {
    userToken() {
      this.getReportById({
        reportId: this.reportId,
        userToken: this.userToken,
      });
    },
  },
  created() {
    this.unsubscribeReport = this.$store.subscribe((mutation, state) => {
      // eslint-disable-next-line max-len
      if (mutation.type === 'assessments/REPORTFETCHED') {
        // eslint-disable-next-line no-case-declarations
        const courseId = state.assessments.combinedReview.report_details.course_id;
        this.getCourseById({ courseId, userToken: this.userToken });
      }
    });
  },
  beforeDestroy() {
    this.unsubscribeReport();
  },
};
</script>
